import queryString from "query-string";
import httpClient from "../httpClient";

const apiUrl = process.env.REACT_APP_TRICOTEUSES_API_URL;

export const dataProvider = {
	getList: async (resource, params) => {
		try {
			const { page, perPage } = params.pagination || {
				page: 1,
				perPage: 10,
			};
			const { field, order } = params.sort || {};
			const filter = { ...params.filter };

			// Process range filters
			for (const [key, value] of Object.entries(filter)) {
				if (value && typeof value === "string" && value.includes("|")) {
					const [startDate, endDate] = value.split("|");
					if (startDate) filter[`${key}.gte`] = startDate;
					if (endDate) filter[`${key}.lte`] = endDate;
					delete filter[key];
				}
			}

			const search = params.search;
			const searchTable = params.searchTable;
			const searchLanguage = params.searchLanguage;
			const include = params.include || params.meta?.include || [];
			const distinct = params.distinct;
			const query = {
				...filter,
				...(field && { sort: `${field}.${order.toLowerCase()}` }),
				...(include.length && { include: include.join(",") }),
				...(search && { search: search }),
				...(searchTable && { searchTable: searchTable }),
				...(searchLanguage && { searchLanguage: searchLanguage }),
				...(distinct && { distinct: distinct }),
				page: page,
				perPage: perPage,
			};
			const url = (resource_) =>
				`${apiUrl}/${resource_}?${queryString.stringify(query)}`;

			const { headers, json } = await httpClient(
				url(resource),
				{ method: "get" },
				false,
			) || {};
			const data = json?.data?.map((resource) => ({
				...resource,
				id: resource.id,
			}));
			const total = Number.parseInt(headers?.get("total"), 10) || 0;
			return { data, total };
		} catch (error) {
			console.log(error);
		}
	},

	getOne: (resource, params) => {
		const include = params.include || [];
		const query = {
			...(include.length && { include: include.join(",") }),
		};
		const url = `${apiUrl}/${resource}/${params.id}?${queryString.stringify(
			query,
		)}`;
		return httpClient(url, { method: "get" }, false)
			.then(({ json }) => ({
				data: { ...json.data, id: json.data.uid },
			}))
			.catch((error) => {
				console.log(error);
			});
	},
};
